<template>
  <div class="column content-box">
    <div class="row">
      <div class="small-8 columns with-right-space">
        <p v-if="!inboxesList.length" class="no-items-error-message">
          {{ $t('INBOX_MGMT.LIST.404') }}
          <router-link
            v-if="isAdmin"
            :to="addAccountScoping('settings/inboxes/new')"
            class="btn btn-config"
          >
            {{ $t('SETTINGS.INBOXES.NEW_INBOX') }}
          </router-link>
        </p>

        <table v-if="inboxesList.length" class="woot-table">
          <tbody>
            <tr v-for="item in inboxesList" :key="item.id">
              <td>
                <img
                  v-if="item.avatar_url"
                  class="woot-thumbnail"
                  :src="item.avatar_url"
                  alt="No Page Image"
                />
                <img
                  v-else
                  class="woot-thumbnail"
                  src="~dashboard/assets/images/flag.svg"
                  alt="No Page Image"
                />
              </td>

              <td>
                <span class="agent-name">{{ item.name }}</span>

                <span v-if="item.channel_type === 'Channel::FacebookPage'">
                  Facebook
                </span>
                <span v-if="item.channel_type === 'Channel::WebWidget'">
                  Website
                </span>
                <span v-if="item.channel_type === 'Channel::TwitterProfile'">
                  Twitter
                </span>
                <span v-if="item.channel_type === 'Channel::TwilioSms'">
                  {{ twilioChannelName(item) }}
                </span>
                <span v-if="item.channel_type === 'Channel::Whatsapp'">
                  Whatsapp
                </span>
                <span v-if="item.channel_type === 'Channel::Sms'"> Sms </span>
                <span v-if="item.channel_type === 'Channel::Email'">
                  Email
                </span>
                <span v-if="item.channel_type === 'Channel::Telegram'">
                  Telegram
                </span>
                <span v-if="item.channel_type === 'Channel::Line'">Line</span>
                <span v-if="item.channel_type === 'Channel::Api'">
                  {{ globalConfig.apiChannelName || 'API' }}
                </span>
              </td>

              <td>
                <span
                  v-if="item.isWPPConnectInbox"
                  :class="{
                    'status-success': item.isWPPConnectActive,
                    'status-alert': !item.isWPPConnectActive,
                  }"
                >
                  {{ item.isWPPConnectMsg }}
                </span>

                <span
                  v-if="item.isWAPIConnectInbox"
                  :class="{
                    'status-success': item.isWAPIConnectActive,
                    'status-alert': !item.isWAPIConnectActive,
                  }"
                >
                  {{ item.isWAPIConnectMsg }}
                </span>

                <span
                  v-if="item.isWA360ConnectInbox"
                  :class="{
                    'status-success': item.isWA360ConnectActive,
                    'status-alert': !item.isWA360ConnectActive,
                  }"
                >
                  {{ item.isWA360ConnectMsg }}
                </span>
              </td>

              <td class="actions-cell">
                <div class="button-wrapper">
                  <router-link
                    v-if="
                      isAdmin &&
                      !(
                        item.channel_type === 'Channel::Whatsapp' &&
                        !item.is_inbox_active
                      )
                    "
                    :to="addAccountScoping(`settings/inboxes/${item.id}`)"
                    custom
                    v-slot="{ navigate }"
                  >
                    <woot-button
                      v-tooltip.top="$t('INBOX_MGMT.SETTINGS')"
                      variant="smooth"
                      size="tiny"
                      icon="settings"
                      color-scheme="secondary"
                      class-names="grey-btn action-btn"
                      style="min-width: 32px; width: 32px; padding: 0"
                      @click="navigate"
                    />
                  </router-link>

                  <woot-button
                    v-if="isAdmin && item.channel_type === 'Channel::Whatsapp'"
                    v-tooltip.top="
                      item.is_inbox_active
                        ? 'Desativar inbox'
                        : 'Reativar inbox'
                    "
                    variant="smooth"
                    :color-scheme="item.is_inbox_active ? 'warning' : 'success'"
                    size="tiny"
                    :icon="
                      item.is_inbox_active
                        ? 'dismiss-circle'
                        : 'checkmark-circle'
                    "
                    style="min-width: 32px; width: 32px; padding: 0"
                    @click="openToggleModal(item)"
                  />

                  <woot-button
                    v-if="isAdmin"
                    v-tooltip.top="$t('INBOX_MGMT.DELETE.BUTTON_TEXT')"
                    variant="smooth"
                    color-scheme="alert"
                    size="tiny"
                    class-names="grey-btn action-btn"
                    :is-loading="!!loading[item.id]"
                    icon="dismiss-circle"
                    style="min-width: 32px; width: 32px; padding: 0"
                    @click="openDelete(item)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="small-4 columns">
        <span
          v-dompurify-html="
            useInstallationName(
              $t('INBOX_MGMT.SIDEBAR_TXT'),
              globalConfig.installationName
            )
          "
        />
      </div>
    </div>

    <settings
      v-if="showSettings"
      :show.sync="showSettings"
      :on-close="closeSettings"
      :inbox="selectedInbox"
    />

    <woot-confirm-delete-modal
      v-if="showDeletePopup"
      :show.sync="showDeletePopup"
      :steps="deleteSteps"
      @on-confirm="confirmDeletion"
      @on-close="closeDelete"
    />

    <woot-confirm-delete-modal
      v-if="showTogglePopup"
      :show.sync="showTogglePopup"
      :title="toggleTitle"
      :message="toggleMessage"
      :confirm-text="toggleConfirmText"
      reject-text="Cancelar"
      :confirm-value="selectedInbox.name"
      :confirm-place-holder-text="'Digite o nome da inbox'"
      @on-confirm="confirmToggle"
      @on-close="closeToggleModal"
    />

    <woot-confirm-delete-modal
      v-if="showSuccessPopup"
      :show.sync="showSuccessPopup"
      title="ATENÇÃO"
      :message="successMessage"
      :show-input="false"
      @on-close="showSuccessPopup = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Settings from './Settings';
import adminMixin from '../../../../mixins/isAdmin';
import accountMixin from '../../../../mixins/account';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import WppConnect from 'dashboard/api/wppconnect';
import WhatsAppWeb from 'dashboard/api/whatsAppWeb';

export default {
  components: {
    Settings,
  },
  mixins: [adminMixin, accountMixin, globalConfigMixin],
  data() {
    return {
      loading: {},
      showSettings: false,
      showDeletePopup: false,
      showTogglePopup: false,
      toggleActionType: null,
      showSuccessPopup: false,
      successMessage: '',
      selectedInbox: {},
    };
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
      currentAccountId: 'getCurrentAccountId',
    }),
    deleteSteps() {
      return [
        {
          title: 'ATENÇÃO',
          message: `🚫 <strong>Risco de perda de dados</strong><br /><br />
      Ao excluir a caixa de entrada, você vai <strong>perder informações essenciais</strong> para sua operação que <strong>não podem ser recuperadas</strong>.<br /><br />
      • Contatos<br />
      • Conversas<br />
      • Mensagens<br />
      • Anexos<br /><br />
      👉 <strong>Recomendamos NÃO EXCLUIR a caixa de entrada.</strong><br /><br />
      Caso não queira perder histórico, faça apenas a desativação para preservar seus dados.`,
          confirmText: 'Continuar',
          rejectText: 'Cancelar',
          showInput: false,
        },
        {
          title: 'ATENÇÃO',
          message: `Esta ação é irreversível.<br /><br />
      Todos os dados desta caixa de entrada <strong>serão apagados em definitivo</strong> e não podem mais ser recuperados.<br /><br />
      👉 <strong>Recomendamos NÃO EXCLUIR a caixa de entrada.</strong>`,
          confirmText: 'Continuar',
          showInput: false,
        },
        {
          title: 'ATENÇÃO',
          message: `Você tem certeza que deseja excluir "<strong>${this.selectedInbox.name}</strong>"?<br /><br />
      Digite o nome da inbox para confirmar.`,
          confirmText: `Excluir ${this.selectedInbox.name}`,
          rejectText: 'Cancelar',
          confirmValue: this.selectedInbox.name,
          confirmPlaceHolderText: 'Digite o nome da inbox',
          showInput: true,
        },
      ];
    },
    deleteConfirmText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.YES')} ${
        this.selectedInbox.name
      }`;
    },
    deleteRejectText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.NO')} ${
        this.selectedInbox.name
      }`;
    },
    confirmDeleteMessage() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.MESSAGE')} ${
        this.selectedInbox.name
      } ?`;
    },
    confirmPlaceHolderText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.PLACE_HOLDER', {
        inboxName: this.selectedInbox.name,
      })}`;
    },
    showDeleteButton() {
      return this.currentUserRole == 'administrator';
    },
    inboxesList() {
      const inboxes = this.$store.getters['inboxes/getInboxes'];

      inboxes.map(async inbox => {
        inbox.isWPPConnectInbox =
          inbox.additional_attributes &&
          inbox.additional_attributes.provider == 'wppconnect';

        inbox.isWPPConnectMsg = 'verificando...';

        if (inbox.isWPPConnectInbox) {
          const res = await this.handleCheckConnection(
            inbox.additional_attributes
          );
          inbox.isWPPConnectActive = res.status;
          inbox.isWPPConnectMsg = res.status ? 'Conectado' : 'Desconectado';
        }

        inbox.isWAPIConnectInbox =
          inbox.provider_config && inbox.provider_config.provider == 'baileys';

        inbox.isWAPIConnectMsg = 'verificando...';

        if (inbox.isWAPIConnectInbox) {
          const res = await this.handleCheckConnection(
            inbox.provider_config,
            'whatsapp_web'
          );
          inbox.isWAPIConnectActive = res.status;
          inbox.isWAPIConnectMsg = res.status ? 'Conectado' : 'Desconectado';
        }

        inbox.isWA360ConnectInbox =
          inbox.channel_type == 'Channel::Whatsapp' &&
          inbox.provider == 'default';

        if (inbox.isWA360ConnectInbox) {
          const res = await this.handleCheckConnection(
            inbox.provider_config,
            'whatsapp'
          );
          inbox.isWA360ConnectActive = res.status;
          inbox.isWA360ConnectMsg = res.status ? 'Conectado' : 'Desconectado';
        }

        return inbox;
      });

      return inboxes || [];
    },
    toggleTitle() {
      return this.toggleActionType === 'deactivate'
        ? 'Desativar Inbox'
        : 'Reativar Inbox';
    },
    toggleMessage() {
      if (this.toggleActionType === 'deactivate') {
        return `🚫 <strong>Risco de perda de dados</strong><br><br>
        Ao <strong>desativar</strong> a caixa de entrada, ela <strong>deixará de receber e enviar mensagens</strong>.<br><br>
        Os históricos permanecerão disponíveis para consulta da equipe, mas não haverá novos contatos.<br><br>
        Para reativá-la, será necessário entrar em contato com o suporte e solicitar a geração de uma nova API KEY.<br><br>
        <strong>Você tem certeza que deseja desativar "${this.selectedInbox.name}"?</strong>
        `;
      }

      return '';
    },
    toggleConfirmText() {
      return this.toggleActionType === 'deactivate'
        ? `Desativar ${this.selectedInbox.name}`
        : `Reativar ${this.selectedInbox.name}`;
    },
  },
  methods: {
    twilioChannelName(item) {
      const { medium = '' } = item;
      if (medium === 'whatsapp') return 'WhatsApp';
      return 'Twilio SMS';
    },
    toggleInbox(inbox) {
      inbox.is_inbox_active = !inbox.is_inbox_active;

      bus.$emit(
        'newToastMessage',
        inbox.is_inbox_active ? 'Inbox reativada' : 'Inbox desativada'
      );
    },
    openSettings(inbox) {
      this.showSettings = true;
      this.selectedInbox = inbox;
    },
    closeSettings() {
      this.showSettings = false;
      this.selectedInbox = {};
    },
    async deleteInbox({ id }) {
      try {
        await this.$store.dispatch('inboxes/delete', id);
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.DELETE.API.ERROR_MESSAGE')
        );
      }
    },
    confirmDeletion() {
      this.deleteInbox(this.selectedInbox);
      this.closeDelete();
    },
    openDelete(inbox) {
      this.showDeletePopup = true;
      this.selectedInbox = inbox;
    },
    closeDelete() {
      this.showDeletePopup = false;
      this.selectedInbox = {};
    },
    async openToggleModal(inbox) {
      this.selectedInbox = inbox;

      if (!inbox.is_inbox_active) {
        await this.confirmToggle();
        return;
      }

      this.toggleActionType = 'deactivate';
      this.showTogglePopup = true;
    },
    closeToggleModal() {
      this.showTogglePopup = false;
      this.toggleActionType = null;
    },
    async confirmToggle() {
      const inbox = this.selectedInbox;

      try {
        const isReactivating = !inbox.is_inbox_active;

        await this.$store.dispatch('inboxes/toggleStatus', {
          accountId: this.currentAccountId,
          inboxId: inbox.id,
          isActive: isReactivating,
        });

        if (isReactivating) {
          this.successMessage = `Caixa de entrada reativada com sucesso.
          Se certifique que ela está enviando e recebendo mensagens.
          Qualquer dúvida entrar em contato com o suporte.`;

          this.showSuccessPopup = false;

          this.$nextTick(() => {
            this.showSuccessPopup = true;
          });
        } else {
          bus.$emit('newToastMessage', 'Inbox desativada com sucesso');
          this.closeToggleModal();
        }
      } catch (error) {
        bus.$emit('newToastMessage', 'Erro ao atualizar inbox');
      }
    },
    async handleCheckConnection(options, type = 'api') {
      if (type == 'whatsapp_web') {
        WhatsAppWeb.loadConfig({
          instance: options.key,
          api_base_url: options.api_base_url,
        });

        const { instance_data } = await WhatsAppWeb.info();
        return { status: !!instance_data.phone_connected };
      }

      if (type == 'whatsapp') {
        return { status: !options?.status_code };
      }

      WppConnect.loadConfig(options);
      return await WppConnect.checkConnectionSession();
    },
  },
};
</script>
<style scoped>
.actions-cell {
  white-space: nowrap;
}

.button-wrapper {
  display: flex;
  align-items: center;
  column-gap: 6px;
}

.button-wrapper > * {
  margin: 0 !important;
}

.button-wrapper .woot-button,
.button-wrapper button {
  margin: 0 !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>